import { create } from 'zustand'
import type { LucideIcon } from 'lucide-react'

// Masaüstü (MDI) çalışma alanı sekme durumu. Yalnızca Tauri'de kullanılır;
// web SaaS bu store'a hiç dokunmaz. Kalıcılık yok — her oturum temiz başlar.
export type WorkTab = {
  id: string
  path: string         // açılış yolu (sekmenin MemoryRouter initialEntries değeri)
  title: string
  icon?: LucideIcon
  currentPath: string  // sekme içi güncel yol (sidebar highlight için)
}

let seq = 0
function genId() {
  seq += 1
  return `tab-${Date.now().toString(36)}-${seq}`
}

interface TabsState {
  tabs: WorkTab[]
  activeId: string | null
  openTab: (path: string, title: string, icon?: LucideIcon) => void
  closeTab: (id: string) => void
  setActive: (id: string) => void
  updateCurrentPath: (id: string, path: string) => void
  reset: (path?: string, title?: string, icon?: LucideIcon) => void
}

export const useTabsStore = create<TabsState>((set, get) => ({
  tabs: [],
  activeId: null,

  openTab: (path, title, icon) => {
    const { tabs } = get()
    const existing = tabs.find((t) => t.path === path)
    if (existing) {
      set({ activeId: existing.id })
      return
    }
    const tab: WorkTab = { id: genId(), path, title, icon, currentPath: path }
    set({ tabs: [...tabs, tab], activeId: tab.id })
  },

  closeTab: (id) => {
    const { tabs, activeId } = get()
    const idx = tabs.findIndex((t) => t.id === id)
    if (idx === -1) return
    const next = tabs.filter((t) => t.id !== id)
    let nextActive = activeId
    if (activeId === id) {
      const neighbor = next[idx] ?? next[idx - 1] ?? null
      nextActive = neighbor?.id ?? null
    }
    set({ tabs: next, activeId: nextActive })
  },

  setActive: (id) => set({ activeId: id }),

  updateCurrentPath: (id, path) =>
    set((s) => ({
      tabs: s.tabs.map((t) => (t.id === id ? { ...t, currentPath: path } : t)),
    })),

  reset: (path = '/dashboard', title = 'Ana Sayfa', icon) => {
    const tab: WorkTab = { id: genId(), path, title, icon, currentPath: path }
    set({ tabs: [tab], activeId: tab.id })
  },
}))
